import React from 'react';
import { formatFriendlyTime } from '../../../utils/common';

interface IProps {
  supplier: any; // Combined data (screening or audit)
  // Retained so callers can still pass it; the retry control lived in the
  // removed Status column, so it is no longer consumed here.
  onRetryScreening?: (databaseId: string) => void;
}

const ActivityHistoryRow: React.FC<IProps> = ({ supplier: activityData }) => {
  const isScreening = activityData.type === 'screening';
  const isFailed = activityData.status?.toLowerCase() === 'failed';

  // For audit log failure entries (log_level = 2), show error styling
  const isAuditError = !isScreening && activityData.message?.startsWith?.('Screening failed:');

  const rowContent = (
    <>
      <div
        style={{
          display: 'flex',
          width: '48px',
          height: '44px',
          padding: '16px',
          alignItems: 'center',
          gap: '12px',
        }}
      ></div>

      {/* Date */}
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {formatFriendlyTime(
              activityData?.screening_timestamp || activityData?.updated_at,
            )}
          </div>
        </div>
      </div>

      {/* Type */}
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {isScreening ? (
              <span className='screening-badge medium'>Screening</span>
            ) : isAuditError ? (
              <span className='screening-badge high'>Error</span>
            ) : (
              <span className='screening-badge low'>Audit</span>
            )}
          </div>
        </div>
      </div>

      {/* User */}
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {isScreening ?
              activityData.screened_by || 'System' :
              activityData.user_name || 'Unknown User'}
          </div>
        </div>
      </div>

      {/* Activity */}
      <div
        className='screening-results-row-default-cell'
        style={{ minWidth: '400px', flex: '3' }}
      >
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {isScreening
              ? activityData.screening_reason || 'Scheduled Screening'
              : activityData.message || activityData.action || 'Database activity'}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div
      className='screening-results-row'
      style={isFailed ? { borderLeft: '3px solid var(--error, #dc2626)' } : undefined}
    >
      {rowContent}
    </div>
  );
};

export default ActivityHistoryRow;
